(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifx-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-section-type="lifx-final"]');
    if (!section) return;
    var cd = section.querySelector('[data-countdown]');
    if (!cd) return;
    var endStr = cd.getAttribute('data-end');
    var endTs;
    if (endStr && endStr.trim()) {
      endTs = new Date(endStr).getTime();
    }
    // If no valid end date set, default to 2d 14h 38m 22s from page load
    if (!endTs || isNaN(endTs) || endTs < Date.now()) {
      endTs = Date.now() + (2*24 + 14) * 3600 * 1000 + 38 * 60 * 1000 + 22 * 1000;
    }
    var d = section.querySelector('[data-cd-d]'),
        h = section.querySelector('[data-cd-h]'),
        m = section.querySelector('[data-cd-m]'),
        s = section.querySelector('[data-cd-s]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var r = Math.max(0, endTs - Date.now());
      var days = Math.floor(r / 86400000); r -= days*86400000;
      var hrs  = Math.floor(r / 3600000); r -= hrs*3600000;
      var min  = Math.floor(r / 60000);   r -= min*60000;
      var sec  = Math.floor(r / 1000);
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hrs);
      if (m) m.textContent = pad(min);
      if (s) s.textContent = pad(sec);
    }
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifx-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fix(li) {
      if (li.dataset.lifxA11y) return;
      li.dataset.lifxA11y = '1';
      li.removeAttribute('role');
      li.removeAttribute('tabindex');
      li.removeAttribute('aria-haspopup');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lifx-footer__cookie-btn';
      btn.setAttribute('aria-haspopup', 'dialog');
      while (li.firstChild) btn.appendChild(li.firstChild);
      li.appendChild(btn);
    }
    function scan() {
      document.querySelectorAll('.lifx-footer li[data-csm-cookie-widget-wrapper]').forEach(fix);
    }
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifx-info-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 6.5"/></svg>';
  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  function initTabs(root) {
    var tabs = [].slice.call(root.querySelectorAll('[data-lit-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-lit-panel]'));
    function show(key) {
      tabs.forEach(function (t) { var on = t.getAttribute('data-lit-tab') === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-lit-panel') === key); });
      root.querySelectorAll('video').forEach(function (v) { if (!v.closest('.lit__panel.is-active')) v.pause(); });
      if (key === 'howto' && root._litAccPlay) root._litAccPlay();
      var strip = root.querySelector('.lit__tabs'), act = root.querySelector('.lit__tab.is-active');
      if (strip && act && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: Math.max(0, act.offsetLeft - strip.offsetLeft - 20), behavior: 'smooth' });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-lit-tab')); }); });
    if (tabs[0]) show(tabs[0].getAttribute('data-lit-tab'));
  }

  function initAcc(root) {
    var acc = root.querySelector('[data-lit-acc]');
    if (!acc) return;
    var rows = [].slice.call(acc.querySelectorAll('[data-lit-acc-row]'));
    var stage = acc.querySelector('[data-lit-acc-stage]');
    function play(scope) { if (!scope) return; scope.querySelectorAll('video').forEach(function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }); }
    function pauseAll() { acc.querySelectorAll('video').forEach(function (v) { v.pause(); }); }
    function fillSlot(row) {
      var slot = row && row.querySelector('[data-lit-acc-slot]');
      if (!slot || slot.dataset.filled) return;
      var t = row.querySelector('template[data-lit-acc-media]');
      if (t) { slot.innerHTML = t.innerHTML; slot.dataset.filled = '1'; }
    }
    function clearSlot(row) {
      var slot = row && row.querySelector('[data-lit-acc-slot]');
      if (!slot || !slot.dataset.filled) return;
      slot.querySelectorAll('video').forEach(function (v) { v.pause(); v.removeAttribute('src'); v.load(); });
      slot.innerHTML = ''; delete slot.dataset.filled;
    }
    function render(row) {
      pauseAll();
      if (isDesktop()) {
        var t = row && row.querySelector('template[data-lit-acc-media]');
        stage.innerHTML = t ? t.innerHTML : '';
        play(stage);
      } else if (row) { fillSlot(row); play(row.querySelector('[data-lit-acc-slot]')); }
    }
    function open(row) {
      rows.forEach(function (r) { var on = r === row; r.classList.toggle('is-open', on); r.querySelector('.lit-acc__head').setAttribute('aria-expanded', on ? 'true' : 'false'); if (!on && !isDesktop()) clearSlot(r); });
      render(row);
    }
    rows.forEach(function (r) {
      r.querySelector('.lit-acc__head').addEventListener('click', function () {
        if (r.classList.contains('is-open')) {
          if (isDesktop()) return;
          r.classList.remove('is-open'); r.querySelector('.lit-acc__head').setAttribute('aria-expanded', 'false'); pauseAll(); clearSlot(r); return;
        }
        open(r);
      });
    });
    root._litAccPlay = function () { render(acc.querySelector('.lit-acc__row.is-open') || rows[0]); };
    var mq = window.matchMedia('(min-width: 990px)');
    var onMq = function () { var cur = acc.querySelector('.lit-acc__row.is-open') || rows[0]; render(cur); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    if (isDesktop() && stage && rows[0]) { var t0 = rows[0].querySelector('template[data-lit-acc-media]'); stage.innerHTML = t0 ? t0.innerHTML : ''; }
    else if (!isDesktop()) { fillSlot(rows[0]); }
  }

  function initSpecs(root) {
    var sp = root.querySelector('[data-lit-sp]');
    if (!sp) return;
    var track = sp.querySelector('[data-lit-sp-track]'), slides = sp.querySelectorAll('[data-lit-sp-slide]');
    var dots = sp.querySelectorAll('[data-lit-sp-dots] i');
    var prev = sp.querySelector('[data-lit-sp-prev]'), next = sp.querySelector('[data-lit-sp-next]'), cur = 0;
    if (slides.length < 2) return;
    function set(i) { cur = i; dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); }); if (prev) prev.disabled = i === 0; if (next) next.disabled = i === slides.length - 1; }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' }); set(i); }
    track.addEventListener('scroll', function () {
      var w = slides[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap || 0);
      var i = Math.round(track.scrollLeft / w);
      if (i !== cur && slides[i]) set(i);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    set(0);
  }

  function initCopy(root) {
    root.querySelectorAll('.lit-spec, .lit-meta__item').forEach(function (row) {
      var v = row.querySelector('[data-copy]'), btn = row.querySelector('.lit-copy');
      if (!v || !btn) return;
      var icon = btn.innerHTML;
      v.addEventListener('click', function () { if (window.matchMedia('(hover: none)').matches) row.classList.toggle('show-copy'); });
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var text = v.textContent.trim();
        var done = function () { row.classList.add('is-copied'); btn.innerHTML = CHECK; clearTimeout(btn._t); btn._t = setTimeout(function () { row.classList.remove('is-copied'); btn.innerHTML = icon; }, 1100); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done).catch(done);
        else { var ta = document.createElement('textarea'); ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (err) {} document.body.removeChild(ta); done(); }
      });
    });
  }

  function initBenSwipe(root) {
    var sw = root.querySelector('[data-lit-bsw]'), dots = root.querySelector('[data-lit-bdots]');
    if (!sw || !dots) return;
    var ds = [].slice.call(dots.children), items = [].slice.call(sw.children);
    function upd() {
      var left = sw.getBoundingClientRect().left, best = 0, bd = Infinity;
      items.forEach(function (it, i) { var d = Math.abs(it.getBoundingClientRect().left - left - 18); if (d < bd) { bd = d; best = i; } });
      if (sw.scrollLeft + sw.clientWidth >= sw.scrollWidth - 4) best = items.length - 1;
      ds.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
    }
    sw.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function init(root) {
    if (!root || root.dataset.litInit) return;
    root.dataset.litInit = '1';
    initAcc(root); initTabs(root); initSpecs(root); initCopy(root); initBenSwipe(root);
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-lit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-lit]');
    var panel = e.target.closest && e.target.closest('[data-lit-panel]');
    if (!root || !panel) return;
    var tab = root.querySelector('[data-lit-tab="' + panel.getAttribute('data-lit-panel') + '"]');
    if (tab) tab.click();
    var row = e.target.closest('[data-lit-acc-row]');
    if (row && !row.classList.contains('is-open')) row.querySelector('.lit-acc__head').click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifx-lifestyle-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.lifx-lhero__vid[data-loop-delay]').forEach(function (wrap) {
    var v = wrap.querySelector('video');
    var wait = parseInt(wrap.getAttribute('data-loop-delay'), 10) || 0;
    if (!v || !wait || v.dataset.lifxHold) return;
    v.dataset.lifxHold = '1';
    v.loop = false;
    v.addEventListener('ended', function () {
      setTimeout(function () {
        v.currentTime = 0;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }, wait);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifx-main-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents, fmt) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, fmt);
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + v;
  }

  function openCart() {
    var R = window.Rebuy, sc = R && (R.SmartCart || R.smartCart);
    if (sc) {
      try { if (typeof sc.refresh === 'function') sc.refresh(); } catch (e) {}
      var fns = ['open', 'show', 'openCart', 'toggle'];
      for (var i = 0; i < fns.length; i++) if (typeof sc[fns[i]] === 'function') { try { sc[fns[i]](); return true; } catch (e) {} }
    }
    document.dispatchEvent(new CustomEvent('rebuy:cart.show', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('rebuy:smartcart.show', { bubbles: true }));
    if (document.querySelector('[data-rebuy-smart-cart], .rebuy-cart, #rebuy-smart-cart')) return true;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    return false;
  }

  function addToCart(items, done) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (window.lifxLoadRebuy) window.lifxLoadRebuy();
    var openedFromReady = false;
    document.addEventListener('lifx:rebuy-ready', function onRebuyReady() {
      document.removeEventListener('lifx:rebuy-ready', onRebuyReady);
      if (!openedFromReady) { openedFromReady = true; openCart(); }
    }, { once: true });
    function openWhenReady(tries) {
      if (openedFromReady || openCart()) { openedFromReady = true; return; }
      if (tries > 0) { setTimeout(function () { openWhenReady(tries - 1); }, 150); return; }
      window.location.href = root + 'cart';
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles: true }));
      if (!openCart()) openWhenReady(33);
      if (done) done();
    }).catch(function () { window.location.href = root + 'cart'; });
  }

  function initGallery(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('[data-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
    var dotsWrap = root.querySelector('[data-dots]');
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    var arrows = root.querySelector('.lmv2__arrows');
    var current = 0;

    if (slides.length < 2) {
      if (arrows) arrows.hidden = true;
      if (dotsWrap) dotsWrap.hidden = true;
    }
    var dots = [];
    if (dotsWrap && slides.length > 1) {
      slides.forEach(function () { var d = document.createElement('span'); d.className = 'lmv2__dot'; dotsWrap.appendChild(d); dots.push(d); });
    }

    function syncVideos() {
      slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (!v) return;
        if (i === current) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); try { v.currentTime = 0; } catch (e) {} }
      });
    }

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
      var at = thumbs[i], rl = at && at.parentElement;
      if (rl && rl.scrollHeight > rl.clientHeight) {
        var top = at.offsetTop - rl.offsetTop, bot = top + at.offsetHeight;
        if (top < rl.scrollTop) rl.scrollTo({ top: top, behavior: 'smooth' });
        else if (bot > rl.scrollTop + rl.clientHeight) rl.scrollTo({ top: bot - rl.clientHeight, behavior: 'smooth' });
      }
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      syncVideos();
    }

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current && slides[i]) setActive(i);
      });
    }, { passive: true });

    root.addEventListener('lmv2:variant', function (e) {
      var id = e.detail && e.detail.mediaId; if (!id) return;
      for (var k = 0; k < slides.length; k++) { if (slides[k].getAttribute('data-media-id') === String(id)) { goTo(k); break; } }
    });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
      t.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) goTo(i); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    slides.forEach(function (s) {
      var v = s.querySelector('video');
      if (v) v.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    setActive(0);
  }

  function initLead(root) {
    var lead = root.querySelector('[data-lead]'), more = root.querySelector('[data-more]');
    if (!lead || !more) return;
    var userOpen = false;
    function check() {
      if (userOpen) return;
      lead.classList.add('is-clamped');
      var lh = parseFloat(getComputedStyle(lead).lineHeight) || 20;
      var hidden = lead.scrollHeight - lead.clientHeight;
      // Only truncate when it saves real space: 2+ hidden lines. Otherwise show it all.
      var worth = hidden > lh * 1.9;
      if (!worth) lead.classList.remove('is-clamped');
      more.hidden = !worth;
    }
    check();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    window.addEventListener('load', check);
    window.addEventListener('resize', check);
    more.addEventListener('click', function () {
      var open = lead.classList.toggle('is-clamped') === false;
      userOpen = open;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.querySelector('span').textContent = open ? 'Read less' : 'Read more';
    });
  }

  function initBuy(root) {
    var form = root.querySelector('form[id^="product-form-"]');
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var atc = form.querySelector('[data-atc]'), atcText = form.querySelector('[data-atc-text]');
    var priceEl = root.querySelector('[data-price]'), wasEl = root.querySelector('[data-was]'), saveEl = root.querySelector('[data-save]');
    var stickyBtn = root.querySelector('[data-sticky-btn]');
    var fpd = Number(root.getAttribute('data-fpd') || 0);
    var fmt = root.getAttribute('data-money-format') || '';
    var label = root.getAttribute('data-atc-label') || 'Add to cart';
    var priceInAtc = root.getAttribute('data-show-price-in-atc') === 'true';
    var saveFormat = root.getAttribute('data-save-format') || 'percent';
    var fsThreshold = Number(root.getAttribute('data-fs-threshold') || 7900);
    var fsAlways = root.getAttribute('data-fs-always') === 'true';
    var fsEl = root.querySelector('[data-free-ship]'), fsSep = null, promiseEl = null;
    var qtyInput = form.querySelector('[data-qty]'), qtyOut = root.querySelector('[data-qty-out]'), qtyMinus = root.querySelector('[data-qty-minus]'), qtyPlus = root.querySelector('[data-qty-plus]'), qtyWrap = root.querySelector('[data-qty-wrap]');
    var st = root.querySelector('[data-st]'), qty = 1, touched = false, cur = null, cartTotal = st ? Number(st.getAttribute('data-cart') || 0) : 0, T = [], cartMap = {};
    function inCart() { return cur ? (cartMap[String(cur.id)] || 0) : 0; }
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}

    function render(v) {
      if (!v) return;
      var now = v.price - fpd;
      var was = fpd > 0 ? v.price : (v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0);
      priceEl.textContent = money(now, fmt);
      if (was) {
        wasEl.textContent = money(was, fmt); wasEl.hidden = false;
        saveEl.textContent = saveFormat === 'amount' ? 'Save ' + money(was - now, fmt) : 'Save ' + Math.round((1 - now / was) * 100) + '%';
        saveEl.hidden = false;
      } else { wasEl.hidden = true; saveEl.hidden = true; }
      atc.disabled = !v.available;
      atc.hidden = !v.available;
      var bis = root.querySelector('[data-bis]'), sold = root.querySelector('[data-sold]'), bisTag = root.querySelector('[data-bis-tag]');
      if (bis) bis.hidden = !!v.available;
      if (sold) sold.hidden = !!v.available;
      if (bisTag) bisTag.value = 'bis-' + v.id;
      var st = document.querySelector('[data-sticky][data-lmv2-owner="' + root.id + '"]');
      if (st) { if (v.available) st.removeAttribute('data-soldout'); else { st.setAttribute('data-soldout', ''); st.classList.remove('is-visible'); } }
      if (stickyBtn) stickyBtn.disabled = !v.available;
      idInput.value = v.id;
      if (qtyWrap) qtyWrap.hidden = !v.available;
      var stEl = root.querySelector('[data-st]'); if (stEl) stEl.hidden = !v.available;
      var bpWrap = root.querySelector('[data-bp]');
      if (bpWrap) { bpWrap.hidden = !v.available; bpWrap.querySelectorAll('[data-bp-add]').forEach(function (b) { b.disabled = !v.available; }); }
      var vsel = root.querySelector('[data-variant-select]'); if (vsel) vsel.value = String(v.id);
      root.dispatchEvent(new CustomEvent('lmv2:variant', { detail: { mediaId: v.featured_media && v.featured_media.id } }));
      cur = v; qty = inCart() || 1; touched = false; sync();
      if (fsEl) {
        var fsShow = fsAlways || now > fsThreshold;
        var fsT = fsEl.querySelector('[data-free-ship-text]');
        if (fsT) fsT.textContent = fsT.getAttribute(fsShow ? 'data-on' : 'data-off');
        fsEl.classList.toggle('is-off', !fsShow);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function sync() {
      if (!cur) return;
      var now = cur.price - fpd, ic = inCart(), line = now * qty;
      if (qtyOut) qtyOut.textContent = qty;
      if (qtyMinus) qtyMinus.disabled = qty <= 1;
      if (qtyInput) qtyInput.value = ic > 0 ? 1 : qty;
      var t = !cur.available ? 'Sold out' : (ic > 0 ? (qty === ic ? 'In cart \u00b7 View cart' : 'Update cart \u00b7 ' + qty + ' total') : label + (priceInAtc ? ' \u00b7 ' + money(line, fmt) : ''));
      atcText.textContent = t; if (stickyBtn) stickyBtn.textContent = cur.available ? label + (priceInAtc ? ' \u00b7 ' + money(now, fmt) : '') : 'Sold out';
      if (!st || !T.length) return;
      var eff = cartTotal + (ic > 0 ? (qty - ic) * now : (touched ? line : 0)), hit = -1, pct = 0, prev = 0, seg = 100 / T.length, nx;
      T.forEach(function (x, i) { if (eff >= x.at) hit = i; });
      nx = T[hit + 1];
      for (var i = 0; i < T.length; i++) { if (eff >= T[i].at) pct = (i + 1) * seg; else { pct = i * seg + (eff - prev) / (T[i].at - prev) * seg; break; } prev = T[i].at; }
      st.querySelector('[data-st-fill]').style.width = pct + '%';
      var dp = hit >= 0 && T[hit].pct ? T[hit].pct : 0, subEl = st.querySelector('[data-st-sub]');
      subEl.innerHTML = dp ? '<b>' + money(Math.round(eff * (100 - dp) / 100), fmt) + '</b> <s>' + money(eff, fmt) + '</s>' : '<b>' + money(eff, fmt) + '</b>';
      st.querySelectorAll('.lmv2-st__step').forEach(function (s, i) { s.classList.toggle('is-on', i <= hit); s.classList.toggle('is-next', i === hit + 1); s.classList.toggle('is-current', i === hit && hit > 0); });
      var m = st.querySelector('[data-st-msg]');
      if (eff === 0) m.innerHTML = 'Spend <b>' + money(T[0].at, fmt) + '</b> for <b>' + T[0].label.toLowerCase() + '</b>, up to <b>' + T[T.length - 1].label + '</b> at ' + money(T[T.length - 1].at, fmt) + '.';
      else if (hit < 0) m.innerHTML = 'Add <b>' + money(nx.at - eff, fmt) + '</b> more for <b>' + nx.label.toLowerCase() + '</b>.';
      else { var won = '<span class="lmv2-st__won">' + (hit === 0 ? '<svg viewBox="0 0 18 16" width="17" height="15" aria-hidden="true"><path d="M1 3.2A1.2 1.2 0 0 1 2.2 2H10v9H1z" fill="currentColor"/><path d="M11 5h3l3 3v3h-6z" fill="currentColor"/><circle cx="5" cy="12" r="2" fill="currentColor" stroke="#E3FF50" stroke-width="1.2"/><circle cx="13.5" cy="12" r="2" fill="currentColor" stroke="#E3FF50" stroke-width="1.2"/></svg>' : '<svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true"><rect x="2.5" y="7.2" width="9" height="6.8" rx="1.6" fill="currentColor"/><path d="M5 7.2V4.9a2.7 2.7 0 0 1 5.3-.7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>') + '' + T[hit].label + ' unlocked</span>'; m.innerHTML = won + (nx ? '<span class="lmv2-st__next">Add <b>' + money(nx.at - eff, fmt) + '</b> more for <b>' + nx.label + '</b></span>' : '<span class="lmv2-st__next">Best tier reached</span>'); }
    }
    function loadCart() {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(r + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (x) { return x.json(); }).then(function (c) { var pid = st ? Number(st.getAttribute('data-pid')) : 0; cartTotal = (c.items || []).reduce(function (s, i) { return s + (!pid || i.product_id === pid ? (i.original_line_price != null ? i.original_line_price : i.line_price) : 0); }, 0); cartMap = {}; (c.items || []).forEach(function (i) { cartMap[String(i.variant_id)] = (cartMap[String(i.variant_id)] || 0) + i.quantity; }); qty = inCart() || 1; touched = false; sync(); }).catch(function () {});
    }
    function loadCartQty() { loadCart(); }
    if (!st) { var lt0; ['cart:refresh', 'rebuy:cart.change', 'rebuy:cart.add'].forEach(function (n) { document.addEventListener(n, function () { clearTimeout(lt0); lt0 = setTimeout(loadCart, 250); }); }); loadCart(); }
    if (st) {
      T.push({ at: fsThreshold, label: 'Free shipping' });
      (st.getAttribute('data-tiers') || '').split(',').forEach(function (p) { var a = p.split(':'), at = Number(a[0]) * 100, d = Number(a[1]); if (at > 0 && d > 0) T.push({ at: at, label: d + '% off', pct: d }); });
      T.sort(function (a, b) { return a.at - b.at; });
      st.querySelector('[data-st-steps]').style.setProperty('--n', T.length);
      st.querySelector('[data-st-steps]').innerHTML = T.map(function (x) { return '<li class="lmv2-st__step"><i class="lmv2-st__dot"></i><span class="lmv2-st__at">' + money(x.at, fmt) + '+</span><span class="lmv2-st__of">' + x.label + '</span></li>'; }).join('');
      var lt; function later() { clearTimeout(lt); lt = setTimeout(loadCart, 250); }
      ['cart:refresh', 'rebuy:cart.change', 'rebuy:cart.add', 'rebuy:cart.updated', 'rebuy:cart.ready'].forEach(function (n) { document.addEventListener(n, later); });
      if (window.fetch && !window.__lmv2CartWatch) {
        window.__lmv2CartWatch = true; var of = window.fetch;
        window.fetch = function (u) { var p = of.apply(this, arguments); try { if (/\/cart\/(add|change|update|clear)/.test(typeof u === 'string' ? u : (u && u.url) || '')) p.then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); }); } catch (e) {} return p; };
        var ox = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (m, u) { try { if (/\/cart\/(add|change|update|clear)/.test(String(u))) this.addEventListener('loadend', function () { document.dispatchEvent(new CustomEvent('cart:refresh')); }); } catch (e) {} return ox.apply(this, arguments); };
      }
      document.addEventListener('visibilitychange', later);
      loadCart();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function () { qty = Math.max(1, qty - 1); sync(); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { qty = Math.min(99, qty + 1); touched = true; sync(); });
    cur = variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || null;
    sync();

    root.querySelectorAll('[data-variant]').forEach(function (btn, _, all) {
      btn.addEventListener('click', function () {
        all.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true');
        var id = Number(btn.getAttribute('data-variant'));
        render(variants.filter(function (v) { return v.id === id; })[0]);
      });
    });

    var vselEl = root.querySelector('[data-variant-select]');
    if (vselEl) vselEl.addEventListener('change', function () { var id = Number(vselEl.value); render(variants.filter(function (v) { return v.id === id; })[0]); });

    root.querySelectorAll('[data-bp-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = Number(btn.getAttribute('data-bp-qty'));
        if (!idInput.value || !q) return;
        btn.classList.add('is-loading'); btn.disabled = true;
        addToCart([{ id: Number(idInput.value), quantity: q }], function () { btn.classList.remove('is-loading'); btn.disabled = false; });
      });
    });

    form.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault(); e.stopImmediatePropagation();
      atc.classList.add('is-loading'); atc.disabled = true;
      var ic = inCart();
      if (ic > 0) {
        if (qty === ic) { atc.classList.remove('is-loading'); atc.disabled = false; if (!openCart()) window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart'; return; }
        var rt = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rt + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: String(idInput.value), quantity: qty }) }).then(function (r) { return r.json(); }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles: true }));
          atc.classList.remove('is-loading'); atc.disabled = false; loadCart(); openCart();
        }).catch(function () { window.location.href = rt + 'cart'; });
        return;
      }
      addToCart([{ id: Number(idInput.value), quantity: qty }], function () { atc.classList.remove('is-loading'); atc.disabled = false; loadCart(); });
    }, true);

    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(atc); else atc.click();
    });
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-sticky]'), atc = root.querySelector('[data-atc]');
    if (!sticky || !atc || !('IntersectionObserver' in window)) return;
    sticky.setAttribute('data-lmv2-owner', root.id);
    if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
    new IntersectionObserver(function (entries) {
      /* only while the real button is still below the fold — never after scrolling past it */
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top > 0 && !sticky.hasAttribute('data-soldout');
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.querySelector('button').tabIndex = show ? 0 : -1;
    }, { threshold: 0 }).observe(atc);
  }

  function initBis(root) {
    var box = root.querySelector('[data-bis]');
    if (!box) return;
    var panel = box.querySelector('[data-bis-panel]'), cta = box.querySelector('[data-bis-open]');
    if (cta && panel) cta.addEventListener('click', function () {
      var opening = panel.hidden;
      panel.hidden = !opening;
      cta.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) { var em = panel.querySelector('input[type="email"]'); if (em) em.focus(); }
    });
    var f = box.querySelector('form'), tag = box.querySelector('[data-bis-tag]');
    /* never stopPropagation here — Shopify's captcha listens at document level */
    if (f && tag) f.addEventListener('submit', function () {
      var phone = f.querySelector('[data-bis-phone]');
      if (!phone) return;
      var digits = (phone.value || '').replace(/[^\d]/g, '');
      phone.removeAttribute('name');
      var base = tag.value.split(',')[0];
      tag.value = digits.length >= 8 && digits.length <= 15 ? base + ',bis-sms-' + digits : base;
    });
  }

  function initRating(root) {
    root.querySelectorAll('.lmv2__rating').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var t = document.querySelector('.jdgm-rev-widg, #judgeme_product_reviews, #shopify-product-reviews, .spr-container, .loox-reviews-default, #looxReviews, [id^="okeReviews"]');
        if (!t) return;
        e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-lmv2]').forEach(function (root) {
      if (root.dataset.lmv2Init) return;
      root.dataset.lmv2Init = '1';
      initGallery(root); initLead(root); initBuy(root); initSticky(root); initRating(root); initBis(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    document.querySelectorAll('body > .lmv2__sticky').forEach(function (s) { s.remove(); });
    init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifx-mood-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lmd2Init) return;
    root.dataset.lmd2Init = '1';
    var t = root.querySelector('[data-lmd2-track]');
    var prev = root.querySelector('[data-lmd2-prev]'), next = root.querySelector('[data-lmd2-next]');
    if (!t) return;
    function step() {
      var c = t.querySelector('.lmd2__card');
      return c ? c.offsetWidth + parseFloat(getComputedStyle(t).columnGap || 0) : t.clientWidth;
    }
    function sync() {
      if (prev) prev.disabled = t.scrollLeft < 4;
      if (next) next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
    t.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-lmd2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('.lmd2__card');
    var track = card && card.parentNode;
    if (track) track.scrollTo({ left: card.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).scrollPaddingLeft || 0), behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifx-mood-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
  function parseHour(s) {
    var m = String(s || '').trim().toUpperCase().match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)?/);
    if (!m) return null;
    var h = parseInt(m[1], 10), mn = m[2] ? parseInt(m[2], 10) : 0;
    if (m[3] === 'PM' && h !== 12) h += 12;
    if (m[3] === 'AM' && h === 12) h = 0;
    return h + mn / 60;
  }
  function fmt(h) {
    var hf = Math.floor(h), mn = Math.round((h - hf) * 60);
    if (mn === 60) { hf++; mn = 0; }
    hf = ((hf % 24) + 24) % 24;
    var ap = hf >= 12 ? 'PM' : 'AM', hh = hf % 12 || 12;
    return hh + ':' + (mn < 10 ? '0' : '') + mn + '<small>' + ap + '</small>';
  }
  function arr(nl) { return Array.prototype.slice.call(nl); }
  function init(root) {
    if (!root || root.dataset.lmd3Init) return;
    root.dataset.lmd3Init = '1';
    var card = root.querySelector('[data-lmd3-card]');
    var slider = root.querySelector('[data-lmd3-slider]');
    var tl = root.querySelector('[data-lmd3-tl]'), body = root.querySelector('[data-lmd3-body]');
    var timeEl = root.querySelector('[data-lmd3-time]'), tag = root.querySelector('[data-lmd3-roomtag]');
    var data = [];
    try { data = JSON.parse(root.querySelector('[data-lmd3-scenes]').textContent); } catch (e) {}
    var allLayers = arr(root.querySelectorAll('[data-lmd3-layer]'));
    var allStatics = arr(root.querySelectorAll('[data-lmd3-static]'));
    var allScenes = arr(root.querySelectorAll('[data-lmd3-scene]'));
    var tabs = arr(root.querySelectorAll('[data-lmd3-tab]'));
    var rcs = arr(root.querySelectorAll('[data-lmd3-rc]'));
    var hasRooms = tabs.length > 0;
    if (hasRooms) card.classList.add('has-rooms');
    var defaultBg = slider ? getComputedStyle(slider).backgroundImage : '';

    var room = -1, layers = [], sceneEls = [], scenes = [], hours = [], max = 0, current = -1;

    function update(pos) {
      if (max < 1) return;
      var lo = Math.floor(pos), hi = Math.min(max, lo + 1), f = pos - lo;
      for (var i = 0; i < layers.length; i++) {
        var op = i === lo ? 1 - f : (i === hi && hi !== lo ? f : 0);
        layers[i].style.opacity = op;
        layers[i].classList.toggle('is-on', op > 0);
      }
      if (timeEl && hours[lo] != null && hours[hi] != null) {
        var a = hours[lo], b = hours[hi]; if (b < a) b += 24;
        timeEl.innerHTML = fmt(a + (b - a) * f);
      } else if (timeEl && scenes[Math.round(pos)]) timeEl.textContent = scenes[Math.round(pos)].time;
      var n = f < .5 ? lo : hi;
      if (n !== current && sceneEls[n]) {
        current = n;
        for (var k = 0; k < sceneEls.length; k++) {
          sceneEls[k].classList.toggle('is-on', k === n);
          if (k === n) sceneEls[k].removeAttribute('aria-hidden'); else sceneEls[k].setAttribute('aria-hidden', 'true');
        }
      }
    }

    function setRoom(i, startAt) {
      setPlaying(false);
      room = i; current = -1;
      var id = String(i);
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.lmd3Tab === id ? 'true' : 'false'); });
      rcs.forEach(function (c) { var on = c.dataset.room === id; c.classList.toggle('is-on', on); if (on) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true'); });
      if (tag) { var rc = rcs.filter(function (c) { return c.dataset.room === id; })[0]; tag.textContent = rc ? rc.dataset.label : ''; }

      layers = []; sceneEls = []; scenes = [];
      allLayers.forEach(function (l, k) {
        var mine = l.dataset.room === id;
        if (mine) { layers.push(l); scenes.push(data[k] || {}); }
        else { l.style.opacity = 0; l.classList.remove('is-on'); }
      });
      allScenes.forEach(function (s) { if (s.dataset.room === id) sceneEls.push(s); else { s.classList.remove('is-on'); s.setAttribute('aria-hidden', 'true'); } });
      var st = allStatics.filter(function (s) { return s.dataset.room === id; })[0];
      allStatics.forEach(function (s) { s.style.opacity = s === st && layers.length < 2 ? 1 : 0; s.classList.toggle('is-on', s === st && layers.length < 2); });

      hours = scenes.map(function (s) { return parseHour(s.time); });
      max = Math.max(0, layers.length - 1);
      var isStatic = max < 1;
      card.classList.toggle('is-static', isStatic);
      if (tl) tl.hidden = isStatic;
      if (body) body.hidden = isStatic && !sceneEls.length;
      if (isStatic) {
        if (layers[0] && !st) { layers[0].style.opacity = 1; layers[0].classList.add('is-on'); }
        if (sceneEls[0]) { sceneEls[0].classList.add('is-on'); sceneEls[0].removeAttribute('aria-hidden'); }
        return;
      }
      slider.max = max;
      var ok = function (c) { return c && !/^rgba\(\s*0\s*,\s*0\s*,\s*0\s*,\s*0\s*\)$/i.test(c) && c !== 'transparent'; };
      var cols = scenes.map(function (s) { return s.color; });
      if (cols.some(ok)) { var lastC = null; cols = cols.map(function (c) { return ok(c) ? (lastC = c) : null; }); var nextC = null; for (var j = cols.length - 1; j >= 0; j--) { if (cols[j]) nextC = cols[j]; else cols[j] = nextC; } for (var j2 = 0; j2 < cols.length; j2++) if (!cols[j2]) cols[j2] = lastC; }
      if (cols.every(ok)) slider.style.backgroundImage = 'linear-gradient(90deg,' + cols.map(function (c, k) { return c + ' ' + (k / max * 100) + '%'; }).join(',') + ')';
      else slider.style.backgroundImage = defaultBg;
      var v = startAt != null ? startAt : 0;
      slider.value = v; update(v);
    }

    function valueForNow() {
      var d = new Date(), now = d.getHours() + d.getMinutes() / 60;
      if (!hours.length || hours.some(function (h) { return h == null; })) return 0;
      if (now <= hours[0]) return 0;
      if (now >= hours[max]) return max;
      for (var i = 0; i < max; i++) if (now >= hours[i] && now <= hours[i + 1] && hours[i + 1] > hours[i]) return i + (now - hours[i]) / (hours[i + 1] - hours[i]);
      return 0;
    }

    var btn = root.querySelector('[data-lmd3-play]'), icon = root.querySelector('[data-lmd3-play-icon]'), lbl = root.querySelector('[data-lmd3-play-label]');
    var playTxt = lbl ? lbl.textContent : 'Play', raf = null, last = 0, pos = 0, PER_SCENE = 6000;
    function tick(t) {
      if (max < 1) { setPlaying(false); return; }
      if (last) {
        pos += (t - last) / PER_SCENE;
        if (pos > max) pos = 0;
        slider.value = pos; update(pos);
      }
      last = t; raf = requestAnimationFrame(tick);
    }
    function setPlaying(on) {
      if (!btn) return;
      if (on && max < 1) on = false;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      icon.innerHTML = on ? '<rect x="3" y="2" width="2.5" height="8" rx=".6"/><rect x="6.5" y="2" width="2.5" height="8" rx=".6"/>' : '<path d="M3 1.5v9l7-4.5z"/>';
      lbl.textContent = on ? 'Pause' : playTxt;
      if (on) { last = 0; pos = parseFloat(slider.value) || 0; if (pos >= max) pos = 0; raf = requestAnimationFrame(tick); }
      else { cancelAnimationFrame(raf); raf = null; }
    }

    if (slider) {
      slider.addEventListener('input', function () { update(parseFloat(slider.value)); });
      slider.addEventListener('pointerdown', function () { if (raf) setPlaying(false); });
    }
    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); setPlaying(!raf); });
    tabs.forEach(function (t) { t.addEventListener('click', function () { setRoom(parseInt(t.dataset.lmd3Tab, 10)); }); });

    setRoom(0);
    if (max >= 1) { var start = valueForNow(); slider.value = start; update(start); }

    root.addEventListener('shopify:block:select', function (e) {
      var el = e.target, r = el.dataset ? el.dataset.room : null;
      if (r == null) return;
      r = parseInt(r, 10);
      if (r !== room) setRoom(r);
      var i = layers.indexOf(el);
      if (i > -1) { slider.value = i; update(i); }
    });
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-lmd3]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifx-setup-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.lifx-svid__frame').forEach(function (f) {
    if (f.dataset.lifxBound) return;
    f.dataset.lifxBound = '1';
    var v = f.querySelector('video');
    if (!v) return;
    var toggle = function () {
      if (v.paused) {
        var p = v.play();
        f.classList.add('is-playing');
        if (p && p.catch) p.catch(function () { f.classList.remove('is-playing'); });
      } else {
        v.pause();
        f.classList.remove('is-playing');
      }
    };
    f.addEventListener('click', toggle);
    f.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
    v.addEventListener('pause', function () { f.classList.remove('is-playing'); });
    v.addEventListener('ended', function () { f.classList.remove('is-playing'); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifx-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  // (Backup — main listener runs from the inline <script> below)

  } catch(e) { console.error(e); }
})();
})();
